// Actions Types

// List
export const LIST_REQUEST = 'BANNER/LIST/REQUEST'
export const LIST_RESPONSE = 'BANNER/LIST/RESPONSE'
export const LIST_DONE = 'BANNER/LIST/DONE'
export const LIST_RESET = 'BANNER/LIST/RESET'
